module.exports = __webpack_public_path__ + "img/template2.5945f19c.jpg";